var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 611 611",
    style: {
      enableBackground: "new 0 0 611 611"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#808080;stroke-width:40.1225;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-3",
    transform: "translate(235.5 423.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_575",
    className: "st0",
    d: "M120.8-365.4l4.6,12.9c9.8,27.6,40.2,42.1,67.9,32.2c1.7-0.6,3.4-1.3,5-2.1l12.4-5.9 c26.5-12.6,58.2-1.3,70.8,25.2c6.8,14.4,6.8,31.1,0,45.6l-5.9,12.4c-12.7,26.5-1.5,58.2,25,70.8c1.7,0.8,3.4,1.5,5.2,2.1l12.9,4.6 c27.7,9.7,42.3,40,32.6,67.7c-5.3,15.3-17.4,27.3-32.6,32.6l-12.9,4.6c-27.6,9.8-42.1,40.2-32.2,67.9c0.6,1.7,1.3,3.4,2.1,5 l5.9,12.4c12.6,26.5,1.3,58.2-25.2,70.8c-14.4,6.8-31.1,6.8-45.6,0l-12.4-5.9c-26.5-12.6-58.2-1.3-70.8,25.2 c-0.8,1.6-1.5,3.3-2.1,5l-4.6,12.9c-9.7,27.7-40,42.3-67.7,32.6c-15.3-5.3-27.3-17.4-32.6-32.6l-4.3-13.2 C6.5,89.8-23.9,75.3-51.5,85.1c-1.7,0.6-3.4,1.3-5.1,2.1l-12.4,6c-26.5,12.6-58.2,1.3-70.8-25.2c-6.8-14.4-6.8-31.1,0-45.6 l5.9-12.4c12.6-26.5,1.3-58.2-25.2-70.8c-1.7-0.8-3.4-1.5-5.1-2.1l-12.9-4.6c-27.7-9.7-42.3-40-32.6-67.7 c5.3-15.3,17.4-27.3,32.6-32.6l12.9-4.3c27.5-9.8,41.9-40.2,32.1-67.8c-0.6-1.7-1.3-3.4-2.1-5l-5.9-12.4 c-12.7-26.5-1.5-58.2,24.9-70.9c14.5-7,31.4-7,46,0l12.4,5.9c26.5,12.6,58.2,1.4,70.8-25c0.8-1.7,1.5-3.4,2.2-5.2l4.6-12.9 c9.9-27.6,40.3-42,67.9-32.1C103.7-392.2,115.5-380.4,120.8-365.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_576",
    className: "st0",
    d: "M192.2-117.5C192.2-50.4,137.8,4,70.7,4S-50.8-50.3-50.8-117.4S3.6-238.9,70.7-238.9h0.1 C137.8-239,192.2-184.6,192.2-117.5L192.2-117.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.25dd77731f3dd916746e673431b34f59.svg";
export { ForwardRef as ReactComponent };